module.exports = __webpack_public_path__ + "media/images/games/35gender/rockandroll-5f676a6b471eb06835b34b9ef69e2c4c.png";